<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title="$t('customer_purchase_order_details.edit')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(autofocus :placeholder='$t("customer_purchase_order_details.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.name') })" v-model="form.name" :label='$t("customer_purchase_order_details.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-select(:placeholder='$t("customer_purchase_order_details.production_status_placeholder")' :danger="$v.form.production_status_id.$invalid && $v.form.production_status_id.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.production_status_display') })" v-model="form.production_status_id" :label='$t("customer_purchase_order_details.production_status_display")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in productionStatus")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-select(:placeholder='$t("customer_purchase_order_details.production_area_placeholder")' :danger="$v.form.production_area_id.$invalid && $v.form.production_area_id.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.production_area_display') })" v-model="form.production_area_id" :label='$t("customer_purchase_order_details.production_area_display")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in productionAreas")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_order_details.delivery_time_placeholder")' :danger="$v.form.delivery_time.$invalid && $v.form.delivery_time.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.delivery_time') })" v-model="form.delivery_time" :label='$t("customer_purchase_order_details.delivery_time")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-date-picker.full-width(type="date" :label="$t('customer_purchase_order_details.delivery_date')" :placeholder="$t('customer_purchase_order_details.delivery_date_placeholder')" :danger="$v.form.delivery_date.$invalid && $v.form.delivery_date.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.delivery_date') })" v-model="form.delivery_date" )
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_order_details.destination_placeholder")' :danger="$v.form.destination.$invalid && $v.form.destination.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.destination') })" v-model="form.destination" :label='$t("customer_purchase_order_details.destination")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_order_details.quantity_placeholder")' :danger="$v.form.quantity.$invalid && $v.form.quantity.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.quantity') })" v-model="form.quantity" :label='$t("customer_purchase_order_details.quantity")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_order_details.unit_price_placeholder")' :danger="$v.form.unit_price.$invalid && $v.form.unit_price.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_order_details.unit_price') })" v-model="form.unit_price" :label='$t("customer_purchase_order_details.unit_price")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-textarea(class="custom__note" height="100px" :placeholder='$t("purchase_orders.notes")' v-model="form.notes" @keyup.enter="setBullets(form.notes)" type="text" :label='$t("purchase_orders.notes")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Manufacturings')

export default {
  name: 'ModalManufacturings',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        },
        production_status_id: {
          required
        },
        production_area_id: {
          required
        },
        delivery_time: {
          required
        },
        delivery_date: {
          required
        },
        destination: {
          required
        },
        quantity: {
          required
        },
        unit_price: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'productionAreas', 'productionStatus'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editProduct',
      'deleteRecord',
      'setModalVisible'
    ]),
    async saveRecord () {
      this.form = {
        ...this.form,
        delivery_date: moment(this.form.delivery_date).format('YYYY-MM-DD')
      }
      this.editProduct(this.form)
    },
    setBullets (payload) {
      const bullet = '•'
      this.form.notes = `${payload}${bullet} `
    }
  }
}
</script>
<style lang="scss">
.margin-top {
  margin-top: -30px;
}
.overflow {
  max-height: 45vh;
  overflow-y: auto;
}
</style>
